import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-onboarding-layout',
  imports: [RouterOutlet],
  template: `
    <div class="onboarding-shell">
      <img src="nyzed-wordmark.png" alt="Nyzed" class="onboarding-logo" />
      <router-outlet />
    </div>
  `,
  styles: [`
    .onboarding-shell {
      min-height: 100vh;
      background: var(--cream, #faf8f5);
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 2rem 1rem 4rem;
    }
    .onboarding-logo {
      height: 32px;
      width: auto;
      margin-bottom: 2.5rem;
    }
  `]
})
export class OnboardingLayoutComponent {}
